export const UserEndpoints = {
  root: '/users',
  address: '/address'
}
